import Model from "../Model";

class Representantmessage extends Model{

    buildUrl ({ param }) {
        return ['internalmessage/getbyemployee', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Representantmessage;